import { render, staticRenderFns } from "./DisputeCaseDetailsForm.vue?vue&type=template&id=4dbf8b83"
import script from "./DisputeCaseDetailsForm.vue?vue&type=script&lang=js"
export * from "./DisputeCaseDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports